import React from "react";
import imagepartical from "../../assests/tech/imagepartical.jpg";
const IntroSection = () => {
  return (
    <>
      {/* --- New Section Added Below --- */}
      <div className="info-section-container">
        <div className="info-content">
          <div className="info-text">
            <h2 className="info-heading">
              Why Choose Securtech For <span className="text-green-600">Certified</span> Ethical Hacking Course In Indore?
            </h2>
            <hr className="info-divider" />
            <ul className="info-list">
              <li><span className="list-icon"></span> EC Council Accredited Training Center in Indore</li>
              <li><span className="list-icon"></span> Offering a structured advanced hacking course designed to teach students everything from the basics to advanced</li>
              <li><span className="list-icon"></span> Learn ethical hacking through practical, real-world scenarios that prepare you for real cybersecurity challenges.</li>
              <li><span className="list-icon"></span> Ethical hackers with real-world experience will teach you advanced techniques and share valuable insights and practical knowledge</li>
              <li><span className="list-icon"></span> Get guidance and placement assistance to help you secure a job after completing the course.</li>
              <li><span className="list-icon"></span> Access to cutting-edge tools and technologies for learning and practicing hacking techniques.</li>
              <li><span className="list-icon"></span> Necessary tools along with study materials are provided</li>
            </ul>
          </div>
          <div className="info-image">
            <img src={imagepartical} alt="Ethical Hacking Course" className="info-img" />
          </div>
        </div>

        <div className="what-we-offer">
          <h3 className="offer-heading">
            What Do We Offer ?
          </h3>
          <hr className="offer-divider" />
        </div>
      </div>
      {/* --- End of New Section --- */}
      
      <style>
        {`
        /* New Global and Font Styles */
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        body {
            font-family: 'Inter', sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f8f9fa;
        }

        /* New Info Section Styles */
        .info-section-container {
            padding: 2rem 1rem;
            max-width: 1200px;
            margin: 0 auto;
        }

        .info-content {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            align-items: center;
            padding: 2rem 0;
        }

        .info-text {
            flex: 1;
        }

        .info-image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .info-heading {
            font-size: 2rem;
            font-weight: 700;
            line-height: 1.2;
            margin-bottom: 0.5rem;
            color: #333;
        }

        .info-heading .text-green-600 {
            color: #6b1e6e;
        }

        .info-divider {
            width: 50px;
            height: 4px;
            background-color: #6b1e6e;
            border: none;
            margin: 0.5rem 0 1.5rem;
        }

        .info-list {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        
        .info-list li {
            font-size: 1rem;
            color: #555;
            margin-bottom: 1rem;
            display: flex;
            align-items: flex-start;
            gap: 1rem;
        }

        .list-icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            min-width: 16px;
            background-color: #6b1e6e;
            border-radius: 50%;
            margin-top: 4px;
        }
        
        .info-img {
            max-width: 100%;
            height: auto;
            border-radius: 6px 181px;
            box-shadow: 0 18px 20px rgba(0, 0, 0, 0.1);
        }

        /* What We Offer Section */
        .what-we-offer {
            margin-top: 2rem;
            padding-bottom: 4rem;
        }
        
        .offer-heading {
            font-size: 1.8rem;
            font-weight: 700;
            color: #333;
            margin-bottom: 0.5rem;
        }

        .offer-divider {
            width: 50px;
            height: 4px;
            background-color: #6b1e6e;
            border: none;
            margin: 0.5rem 0 1.5rem;
        }

        /* Media Queries for Responsiveness */
        @media (max-width: 768px) {
            .info-content {
                flex-direction: column;
            }
        }
        @media (min-width: 769px) {
            .info-content {
                flex-direction: row;
                justify-content: space-between;
                gap: 4rem;
            }
        }
      `}
      </style>
    </>
  );
};

export default IntroSection;
